import type { GameTheme } from "@skillscratch/shared-types";
import background from "./background.webp";
import name from "./name.webp";
import overlay from "./overlay.webp";
import card from "./card.png";

export const millionaireMaker = {
  id: "millionaire-maker",
  name: "Millionaire Maker",
  
  colorScheme: {
    tileColors: [
      { background: "#7DD3FC", text: "#fff" },  // very bright blue (sky-300 in Tailwind)
      { background: "#60A5FA", text: "#fff" },  // bright blue (blue-400 in Tailwind)
      { background: "#3B82F6", text: "#fff" },  // medium-dark blue (blue-500 in Tailwind)
      { background: "#2563EB", text: "#fff" },  // dark blue (blue-600 in Tailwind)
    ],
    overlayPattern: overlay,
    overlayColor: "#1D4ED8",  // blue-700 in Tailwind
    scratchColor: "#1E40AF",  // blue-800 in Tailwind
    
    controlColor: "#1E3A8A",  // blue-900 in Tailwind
    onControlColor: "#fff",
  },
  
  nameImage: name,
  background: background,
  card: card,
} satisfies GameTheme;